module.exports = __webpack_public_path__ + "img/logo.cad3a32c.png";